var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",style:({
    backgroundImage: _vm.content.header_background
      ? ("url(" + (_vm.content.header_background.url) + ")")
      : ''
  })},[_c('container',[(_vm.content.collaborators.length)?_c('collaborators-box',{attrs:{"collaborators":_vm.content.collaborators}}):_vm._e(),(_vm.content.header_copy)?_c('prismic-text',{attrs:{"blocks":_vm.content.header_copy || []}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }